import React from 'react'
import { CheckCircleOutlined } from "@ant-design/icons";
import './Selling.scss';

export default function Selling() {
    return (
        <div className="Selling">
        <div className="container Selling__big ">
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="Selling__left">
                <h1>
                  <div>A whole world of freelance</div>
                  talent at your fingertips
                </h1>
                <div className="Selling__content__budget">
                  <div>
                    <i>
                      <CheckCircleOutlined />
                    </i>
                    <span>The best for every budget</span>
                    <div className="Selling__infor">
                      <span>
                        Find high-quality services at every price point. No
                        hourly rates,
                      </span>
                      <br></br>
                      <span> just project-based pricing.</span>
                    </div>
                  </div>
                </div>
                <div className="Selling__content__budget">
                  <div>
                    <i>
                      <CheckCircleOutlined />
                    </i>
                    <span>The best for every budget</span>
                    <div className="Selling__infor">
                      <span>
                        Find high-quality services at every price point. No
                        hourly rates,
                      </span>
                      <br></br>
                      <span> just project-based pricing.</span>
                    </div>
                  </div>
                </div>
                <div className="Selling__content__budget">
                  <div>
                    <i>
                      <CheckCircleOutlined />
                    </i>
                    <span>The best for every budget</span>
                    <div className="Selling__infor">
                      <span>
                        Find high-quality services at every price point. No
                        hourly rates,
                      </span>
                      <br></br>
                      <span> just project-based pricing.</span>
                    </div>
                  </div>
                </div>
                <div className="Selling__content__budget">
                  <div>
                    <i>
                      <CheckCircleOutlined />
                    </i>
                    <span>The best for every budget</span>
                    <div className="Selling__infor">
                      <span>
                        Find high-quality services at every price point. No
                        hourly rates,
                      </span>
                      <br></br>
                      <span> just project-based pricing.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6  Selling__right">
              <img
                src="https://fiverr-res.cloudinary.com/q_auto,f_auto,w_700,dpr_1.0/v1/attachments/generic_asset/asset/089e3bb9352f90802ad07ad9f6a4a450-1599517407052/selling-proposition-still-1400-x1.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    )
}
